import { InformeCumplimiento } from '../../model/informe/informe-cumplimiento';
import { ContactoInforme } from '../../model/informe/contacto-informe';
import { FiltroCumplimientos } from 'src/app/presentation/informes-rechazados/consultar-cumplimientos-form.component';

/** Datos del formulario "Enviar Informe" (modal). */
export interface EnvioInformeData {
  observaciones: string;
  tipoInforme: 'P' | 'F';
  mailAprobacion: boolean;
  informes: InformeCumplimiento[];
}

/** Resultado retornado por el backend tras enviar el informe. */
export interface EnvioInformeResultado {
  exito: boolean;
  mensaje: string;
  nmRadicado?: string;
  idDocumentoP8?: string;
}

/**
 * Página de informes de cumplimiento rechazados, tal como la entrega el backend
 * (ver InformeCumplimientoPageResponse). Se propaga completa hasta el componente
 * para permitir paginación real de servidor (page/size/totalElements) en vez de
 * traer siempre el máximo permitido y paginar/truncar en cliente.
 */
export interface PaginaInformesCumplimiento {
  content: InformeCumplimiento[];
  totalElements: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}

/**
 * Puerto Abstracto: InformeCumplimientoRepository
 *
 * Define el contrato para consulta y envío de informes de cumplimiento.
 * Legacy: FilterCumplimProgPresenter / NotificarInformeHandler
 */
export abstract class InformeCumplimientoRepository {

  /**
   * Consulta una página de informes de cumplimiento pendientes (rechazados).
   *
   * @param filtro criterios de búsqueda
   * @param page   número de página 0-based
   * @param size   tamaño de página
   */
  abstract consultarPendientes(
    filtro: FiltroCumplimientos,
    page: number,
    size: number
  ): Promise<PaginaInformesCumplimiento>;

  /**
   * Envía/carga un informe (multipart) al backend.
   */
  abstract enviarInforme(data: EnvioInformeData, archivo: File): Promise<EnvioInformeResultado>;

  // --- Contactos ---
  // El DNI del usuario lo resuelve el backend desde la sesión SSO (SesionUsuarioResolver),
  // por lo que NO se envía desde el frontend (evita IDOR / spoofing de identidad).

  abstract gestionarContactos(nmconsecutivoInforme: number, cumplimientos: string): Promise<ContactoInforme[]>;

  abstract listarContactos(nmconsecutivoInforme: number): Promise<ContactoInforme[]>;

  abstract crearContactos(nmconsecutivoInforme: number, contactos: ContactoInforme[]): Promise<void>;

  abstract actualizarContacto(nmconsecutivoInforme: number, contacto: ContactoInforme): Promise<void>;

  abstract eliminarContacto(nmconsecutivoInforme: number, nmconsecutivo: number): Promise<void>;
}
